module.exports = __webpack_public_path__ + "img/xwdt-icon.d6bd2c26.png";